import { useWatch } from 'react-hook-form';

import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import BaseTipModal from 'reservations/checklessPayments/components/BaseTipModal';
import { SaveChecklessButton } from 'reservations/checklessPayments/components/SaveChecklessButon';
import {
  SaveExistingPaymentButton,
  SaveTokenButton
} from 'reservations/checklessPayments/components/SavePaymentButton';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';

const AddTipModal = () => {
  const hasVisitId = useHasVisitId();
  const { open } = useModal();
  const token = useWatch({ name: 'token' });
  const { hasPaymentMethods } = useDinerAccount();
  const [cardDetails] = useWatch({ name: ['cardDetails'] });

  const handleBack = () =>
    open(
      hasPaymentMethods
        ? ModalType.ChecklessSelectCard
        : cardDetails
          ? ModalType.ChecklessReviewUnsavedCard
          : ModalType.ChecklessAddCard
    );
  const handleClick = () => {
    open(ModalType.ChecklessEnrollmentComplete);
  };

  const handleSaveFailed = () => {
    open(ModalType.ChecklessAddCard, { cardDeclinedError: true });
  };

  const Button = hasVisitId
    ? SaveChecklessButton
    : token
      ? SaveTokenButton
      : SaveExistingPaymentButton;

  return (
    <BaseTipModal
      Button={Button}
      handleBack={handleBack}
      handleClick={handleClick}
      handleSaveFailed={handleSaveFailed}
    />
  );
};

export default AddTipModal;
